import './DownloadPage.css';

import {
  useAppDispatch,
  useAppSelector,
} from 'app/hooks';
import {
  getDownloadData,
  selectDownload,
} from 'features/downloads/downloadSlice';
import { useEffect, useState } from 'react';
import PdfViewModal from 'components/elements/Modal/PdfViewModal'

const DownloadPage = () => {
  const dispatch = useAppDispatch();
  const {
    data, 
    pending, 
  } = useAppSelector(selectDownload);

  const [isPDFViewerOpen, setIsPDFViewerOpen] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState('');

  useEffect(() => {
    
    dispatch(getDownloadData())
  }, [])

  
  const handleClose = () => {
    setIsPDFViewerOpen(false)
}

  const cardView = (item:any, index:number) => {
    return (
      <div className="card notification-card notification-invitation" key={'download_'+index}>
        <div className="card-body">
          <table>
            <tr>
              <td style={{ width: "70%" }} className="d-flex"><img src="images/pdf-icon.png" height={"70"} /><div className="card-title d-flex justify-content-start align-items-center ps-3">{item.download_name}</div></td>
              <td style={{ width: "30%" }}>
                <button type="button" onClick={() => {
                    setSelectedPdf(item.download_link)
                    setIsPDFViewerOpen(true)
                }} className="btn btn-primary">View</button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    )
  }
  return (
  <>
    <div className="row notification-container download p-3 h-100 overflow-auto">
      {/* <h2 className="text-center text-white pb-2">Downloads</h2> */}
      {data?.length > 0 && data.map((item:any, key:number) => cardView(item, key))}
      {data?.length === 0 && <div className="col-12 justify-content-center text-align-center text-white fs-5">No downloads available!</div>}
      <PdfViewModal title="PDF" link={selectedPdf} isOpen={isPDFViewerOpen} handleClose={handleClose}/>

    </div>
  </>
)
};

export default DownloadPage;
